import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { string } from '../../../../../localization';
import {
  ORDER_DETAILS_FORM,
  PROJECT_SUBMISSION_STATE
} from '../../../../../utilities/constants/Constants';
import { resumeFeedbackCookie } from '../../../../../utilities/CookieUtils/CookieUtils';
import { isSignageSuiteProduct } from '../../../../../utilities/HelperFunctions/HelperFunctions';
import * as signageHelperFunctions from '../../../../../utilities/HelperFunctions/SignageHelperFunctions';
import * as finalCheckActions from '../../../../../redux/finalCheckActions';
import * as fabricCanvasActions from '../../../../../redux/fabricCanvasActions';
import * as blockChainActions from '../../../../../redux/blockChainActions';
import * as homeActions from '../../../../../redux/homeActions';
import CustomInput from '../../../../../UI/CustomInput/CustomInput';
import * as formValidation from './FormValidation';
import './OrderDetails.scss';
import { Icons } from '../../../../../utilities';
import { Popover } from 'reactstrap';
import SerialNumberDialogue from '../../../../../components/SerialNumberDialogue/SerialNumberDialogue';
import { LegalText } from '../../../ModelComponent/LegalText';
import { saveProjectAndCall } from '../../../../../redux/projectSaveAndLoader';
import { setCurrentPageIndex } from '../../../../../redux/pageControllerActions';
import { doesProjectHasPixelatedImage } from '../../../../../redux/actions/pixelationHandler';

const { useState } = require('react');

const formElementTemplate = {
  id: '',
  label: '',
  inputConfig: {
    type: 'text',
    placeholder: '',
    options: [],
    readOnly: false,
    moreInfoHandler: null,
    customClass: ''
  },
  value: '',
  canShow: null,
  validation: {
    required: true,
    validationCheck: null,
    errorMessage: '',
    valid: true
  }
};

const getInitialDict = (
  id,
  label,
  config,
  value,
  visibilityCheck,
  validation
) => {
  const initialValue = { ...formElementTemplate };
  initialValue.id = id;
  initialValue.label = label;
  initialValue.inputConfig = config;
  initialValue.value = value;
  initialValue.canShow = visibilityCheck;
  initialValue.validation = validation;
  return initialValue;
};

const orderDetails = props => {
  const {
    dispatchers,
    project,
    envData,
    storeData,
    orderFormData,
    feedbackState,
    projectSubmissionState,
    finalCheckTimer,
    category
  } = props;

  const [
    disableClickForSubmitButton,
    setDisableClickForSubmitButton
  ] = useState(false);
  const [submitState, setSubmitState] = useState('VALID');
  const [moreInfoActiveElement, setMoreInfoActiveElement] = useState(null);

  const [projectNameElement, setProjectNameElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.PROJECT_NAME,
      string.PROJECT_NAME_KEY,

      { type: 'text', placeholder: '', readOnly: false, moreInfoHandler: null },
      project.name,
      dispatchers.formValidation.shouldShowProjectNameField,
      {
        required: true,
        validationCheck: formValidation.validateProjectName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [firstNameElement, setFirstNameElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.FIRST_NAME,
      string.FIRST_NAME_KEY,

      { type: 'text', placeholder: '', readOnly: false, moreInfoHandler: null },
      orderFormData.firstName,
      dispatchers.formValidation.shouldShowFirstAndLastNameField,
      {
        required: true,
        validationCheck: formValidation.validateFirstName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [lastNameElement, setLastNameElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.LAST_NAME,
      string.LAST_NAME_KEY,

      { type: 'text', placeholder: '', readOnly: false, moreInfoHandler: null },
      orderFormData.lastName,
      dispatchers.formValidation.shouldShowFirstAndLastNameField,
      {
        required: true,
        validationCheck: formValidation.validateLastName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [addressElement, setAddressElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.ADDRESS,
      string.ADDRESS_KEY,

      { type: 'text', placeholder: '', readOnly: false, moreInfoHandler: null },
      orderFormData.address,
      dispatchers.formValidation.shouldShowAddressField,
      {
        required: true,
        validationCheck: formValidation.validateAddressField,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [cityElement, setCityElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.CITY,
      string.CITY_KEY,

      { type: 'text', placeholder: '', readOnly: false, moreInfoHandler: null },
      orderFormData.city,
      dispatchers.formValidation.shouldShowCityField,
      {
        required: true,
        validationCheck: formValidation.validateCityName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [countryElement, setCountryElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.COUNTRY,
      string.COUNTRY_KEY,
      {
        type: 'dropdown',
        placeholder: string.SELECT_COUNTRY,
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.country,
      dispatchers.formValidation.shouldShowCountryField,
      {
        required: true,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [stateElement, setStateElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.STATE,
      string.STATE_KEY,
      {
        type: 'dropdown',
        placeholder: string.SELECT_SALUTATION,
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.state,
      dispatchers.formValidation.shouldShowStateField,
      {
        required: true,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [zipCodelement, setZipCodeElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.ZIP_CODE,
      string.ZIP_KEY,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.zipCode,
      dispatchers.formValidation.shouldShowZipField,
      {
        required: true,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [phoneNumberElement, setPhoneNumberElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.PHONE_NUMBER,
      string.PHONE_NUMBER_KEY,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.phoneNumber,
      dispatchers.formValidation.shouldShowPhoneNumberField,
      {
        required: true,
        validationCheck: formValidation.validatePhoneNumber,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [customerNameElement, setCustomerNameElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.CUSTOMER_NAME,
      string.YOUR_NAME_KEY,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null
      },
      project.customerName,
      dispatchers.formValidation.shouldShowCustomerNameField,
      {
        required: true,
        validationCheck: formValidation.validateCustomerName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [customerEmailElement, setCustomerEmailElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.CUSTOMER_EMAIL,
      string.EMAIL_KEY,
      {
        type: 'text',
        placeholder: 'name@email.com',
        readOnly: false,
        moreInfoHandler: null
      },
      project.customerEmail,
      dispatchers.formValidation.shouldShowCustomerEmailField,
      {
        required:
          envData.wallart_lite_external_link ||
          dispatchers.signageHelperFunctions.isWestcoastAccount() ||
          dispatchers.signageHelperFunctions.isShippingDetailsEnabled(),
        validationCheck: formValidation.validateCustomerEmail,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [companyNameElement, setCompanyNameElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.COMPANY_NAME,
      string.COMPANY_NAME,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.companyName,
      dispatchers.formValidation.shouldShowCompanyNameField,
      {
        required: true,
        validationCheck: formValidation.validateCompanyName,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [postalAddressElement, setPostalAddressElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.POSTAL_ADDRESS,
      string.POSTAL_ADDRESS,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.postalAddress,
      dispatchers.formValidation.shouldShowPostalAddressField,
      {
        required: true,
        validationCheck: formValidation.validatePostalAddressField,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [orderNumberElement, setOrderNumberElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.ORDER_NUMBER,
      string.ORDER_NUMBER,
      {
        type: 'text',
        placeholder: '',
        readOnly: true,
        moreInfoHandler: null
      },
      signageHelperFunctions.couponCodeValue(),
      dispatchers.formValidation.shouldShowOrderNumberField,
      {
        required: false,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [invoiceElement, setInvoiceElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.INVOICE,
      string.INVOICE_UPLOAD,
      {
        type: 'upload',
        placeholder: string.CHOOSE_FILE_KEY,
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.invoiceFile,
      dispatchers.formValidation.shouldShowInvoiceUploadField,
      {
        required: true,
        validationCheck: formValidation.validateInvoiceFile,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [serialNumberElement, setSerialNumberElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.SERIAL_NUMBER,
      string.SERIAL_NUMBER_KEY,
      {
        type: 'text',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: id => setMoreInfoActiveElement(id)
      },
      orderFormData.serialNumber,
      dispatchers.formValidation.shouldShowSerialNumberField,
      {
        required: true,
        validationCheck: formValidation.validateSerialNumber,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [extraInfoElement, setExtraInfoElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.EXTRA_INFO,
      string.EXTRA_INFO_KEY,
      {
        type: 'paragraph',
        placeholder: string.PLACEHOLDER_EXTRA_INFO_KEY,
        readOnly: false,
        moreInfoHandler: null
      },
      orderFormData.extraInfo,
      dispatchers.formValidation.shouldShowExtraInfoField,
      {
        required:
          envData.wallart_lite_external_link && storeData.extraInfoMandatory,
        validationCheck: formValidation.validateExtraInfo,
        errorMessage: '',
        valid: true
      }
    )
  );

  const [instructionElement, setInstructionElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.INSTRUCTION,
      string.SEND_INSTALLATION_INSTRUCTION_KEY,
      {
        type: 'checkbox',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null,
        customClass: 'checkBox-field'
      },
      orderFormData.sendInstallationInstruction,
      dispatchers.formValidation.shouldShowInstallationInstruction,
      {
        required: false,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [termsAndConditionsElement, setTermsAndConditionsElement] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.TERMS_AND_CONDITIONS,
      string.TERMS_AND_CONDITIONS,
      {
        type: 'checkbox',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null,
        customClass: 'checkBox-field'
      },
      orderFormData.termsAndConditionState,
      dispatchers.formValidation.shouldShowCheckBoxForTurkey,
      {
        required: true,
        validationCheck: value => ({ isValid: value, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [
    personalInformationConditionElement,
    setPersonalInformationConditionElement
  ] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.PERSONAL_INFORMATION_CONDITION,
      string.PERSONAL_INFORMATION_CONDITION,
      {
        type: 'checkbox',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null,
        customClass: 'checkBox-field'
      },
      orderFormData.personalInformationCondition,
      dispatchers.formValidation.shouldShowCheckBoxForTurkey,
      {
        required: false,
        validationCheck: () => ({ isValid: true, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  const [
    serviceProviderConditionElement,
    setServiceProviderConditionElement
  ] = useState(
    getInitialDict(
      ORDER_DETAILS_FORM.SERVICE_PROVIDER_CONDITION,
      string.SERVICE_PROVIDER_CONDITION,
      {
        type: 'checkbox',
        placeholder: '',
        readOnly: false,
        moreInfoHandler: null,
        customClass: 'checkBox-field'
      },
      orderFormData.serviceProviderCondition,
      dispatchers.formValidation.shouldShowCheckBoxForTurkey,
      {
        required: true,
        validationCheck: value => ({ isValid: value, errorMessage: '' }),
        errorMessage: '',
        valid: true
      }
    )
  );

  useEffect(() => {
    if (dispatchers.formValidation.shouldShowCountryField()) {
      formValidation.fetchCountriesData((fetchedCountries, selectedCountry) => {
        const newCountryElement = { ...countryElement };
        const newCountryElementConfig = { ...newCountryElement.inputConfig };
        newCountryElementConfig.options = fetchedCountries;
        newCountryElement.inputConfig = newCountryElementConfig;
        newCountryElement.value = selectedCountry;
        setInputElement(newCountryElement);
      });
    }
  }, []);

  useEffect(() => {
    if (
      countryElement.value &&
      dispatchers.formValidation.shouldShowCountryField()
    ) {
      formValidation.fetchStateData(
        countryElement.value.value,
        (fetchedStates, hasZipCode) => {
          const newStateElement = { ...stateElement };
          const newStateElementConfig = { ...newStateElement.inputConfig };
          newStateElementConfig.options = fetchedStates;
          newStateElement.inputConfig = newStateElementConfig;
          const [selectedState] = fetchedStates;
          newStateElement.value = selectedState;
          setInputElement(newStateElement);

          if (!hasZipCode) {
            const newZipCodeElement = { ...zipCodelement };
            newZipCodeElement.canShow = () => false;
            setInputElement(newZipCodeElement);
          } else {
            const newZipCodeElement = { ...zipCodelement };
            newZipCodeElement.canShow =
              dispatchers.formValidation.shouldShowZipField;
            setInputElement(newZipCodeElement);
          }
        }
      );
    }
  }, [countryElement]);

  useEffect(() => {
    if (projectSubmissionState == PROJECT_SUBMISSION_STATE.SUBMIT_STATE) {
      continueSubmitWithSaveAndOrder();
    }
  }, [projectSubmissionState]);

  const orderTitle = dispatchers.formValidation.getOrderButtonTitle();

  const getInputElement = id => {
    switch (id) {
      case ORDER_DETAILS_FORM.PROJECT_NAME:
        return projectNameElement;
      case ORDER_DETAILS_FORM.FIRST_NAME:
        return firstNameElement;
      case ORDER_DETAILS_FORM.LAST_NAME:
        return lastNameElement;
      case ORDER_DETAILS_FORM.ADDRESS:
        return addressElement;
      case ORDER_DETAILS_FORM.CITY:
        return cityElement;
      case ORDER_DETAILS_FORM.COUNTRY:
        return countryElement;
      case ORDER_DETAILS_FORM.STATE:
        return stateElement;
      case ORDER_DETAILS_FORM.ZIP_CODE:
        return zipCodelement;
      case ORDER_DETAILS_FORM.PHONE_NUMBER:
        return phoneNumberElement;
      case ORDER_DETAILS_FORM.CUSTOMER_NAME:
        return customerNameElement;
      case ORDER_DETAILS_FORM.CUSTOMER_EMAIL:
        return customerEmailElement;
      case ORDER_DETAILS_FORM.COMPANY_NAME:
        return companyNameElement;
      case ORDER_DETAILS_FORM.POSTAL_ADDRESS:
        return postalAddressElement;
      case ORDER_DETAILS_FORM.ORDER_NUMBER:
        return orderNumberElement;
      case ORDER_DETAILS_FORM.INVOICE:
        return invoiceElement;
      case ORDER_DETAILS_FORM.SERIAL_NUMBER:
        return serialNumberElement;
      case ORDER_DETAILS_FORM.EXTRA_INFO:
        return extraInfoElement;
      case ORDER_DETAILS_FORM.INSTRUCTION:
        return instructionElement;
      case ORDER_DETAILS_FORM.TERMS_AND_CONDITIONS:
        return termsAndConditionsElement;
      case ORDER_DETAILS_FORM.PERSONAL_INFORMATION_CONDITION:
        return personalInformationConditionElement;
      case ORDER_DETAILS_FORM.SERVICE_PROVIDER_CONDITION:
        return serviceProviderConditionElement;
      default:
        return {};
    }
  };

  const setInputElement = inputElement => {
    switch (inputElement.id) {
      case ORDER_DETAILS_FORM.PROJECT_NAME:
        setProjectNameElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.FIRST_NAME:
        setFirstNameElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.LAST_NAME:
        setLastNameElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.ADDRESS:
        setAddressElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.CITY:
        setCityElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.COUNTRY:
        setCountryElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.STATE:
        setStateElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.ZIP_CODE:
        setZipCodeElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.PHONE_NUMBER:
        setPhoneNumberElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.CUSTOMER_NAME:
        setCustomerNameElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.CUSTOMER_EMAIL:
        setCustomerEmailElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.COMPANY_NAME:
        setCompanyNameElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.POSTAL_ADDRESS:
        setPostalAddressElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.ORDER_NUMBER:
        setOrderNumberElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.INVOICE:
        setInvoiceElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.SERIAL_NUMBER:
        setSerialNumberElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.EXTRA_INFO:
        setExtraInfoElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.INSTRUCTION:
        setInstructionElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.TERMS_AND_CONDITIONS:
        setTermsAndConditionsElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.PERSONAL_INFORMATION_CONDITION:
        setPersonalInformationConditionElement(inputElement);
        break;
      case ORDER_DETAILS_FORM.SERVICE_PROVIDER_CONDITION:
        setServiceProviderConditionElement(inputElement);
        break;
      default:
        break;
    }
  };

  const textChangeHandler = (value, id) => {
    const inputElement = { ...getInputElement(id) };
    inputElement.value = value;
    setInputElement(inputElement);
  };

  const checkPixelation = () => {
    const hasPixelation = dispatchers.doesProjectHasPixelatedImage(project);
    if (hasPixelation && storeData.warnMessageOnPixelation) {
      const dict = {
        header: string.PIXELATION_WARNING_KEY,
        description: string.PIXELATED_TEXT_BEFORE_SUBMIT_KEY,
        onclick: () => handleSubmit(),
        onCancel: () =>
          dispatchers.finalCheckActions.onEditDesign(
            dispatchers.setCurrentPageIndex,
            category
          ),
        buttonTitles: {
          finish: string.SUBMIT_BUTTON_KEY,
          cancel: string.Go_BACK_KEY
        }
      };
      dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (!disableClickForSubmitButton) {
      setDisableClickForSubmitButton(true);
      let isValidForm = true;
      formElements.forEach(formElement => {
        let isValidElement = true;
        let elementErrorMessage = '';
        const { validation } = formElement;
        if (
          validation.required ||
          (formElement.value && formElement.value != '')
        ) {
          const { isValid, errorMessage } = validation.validationCheck(
            formElement.value
          );
          isValidElement = isValid;
          elementErrorMessage = errorMessage;
        }
        const newFormElement = { ...formElement };
        const newFormElementValidation = { ...formElement.validation };
        newFormElementValidation.errorMessage = elementErrorMessage;
        newFormElementValidation.valid = isValidElement;
        newFormElement.validation = newFormElementValidation;
        setInputElement(newFormElement);

        isValidForm = isValidForm && isValidElement;
      });

      if (isValidForm) {
        setSubmitState('VALID');
        const shouldShowFeedback = resumeFeedbackCookie(
          envData.feedback_duration
        );
        if (
          (shouldShowFeedback === undefined || !shouldShowFeedback) &&
          feedbackState &&
          storeData.showFeedback
        ) {
          dispatchers.fabricCanvasActions.setProjectSubmissionState(
            PROJECT_SUBMISSION_STATE.CONTINUE_ON_CLOSE_STATE
          );
          dispatchers.fabricCanvasActions.setFeedbackDialogue(true);
        } else {
          continueSubmitWithSaveAndOrder();
        }
      } else {
        setSubmitState('ERROR');
        setDisableClickForSubmitButton(false);
      }
    }
  };

  const continueSubmitWithSaveAndOrder = () => {
    dispatchers.finalCheckActions.setFormDetailsInProject(formElements);
    dispatchers.saveProjectAndCall().then(() => {
      submitAfterSaveActions();
    });
  };

  const checkForPrivacyStatement = () => {
    if (dispatchers.formValidation.shouldShowCheckBoxForTurkey()) {
      if (dispatchers.formValidation.shouldShowPrivacyStatementLink()) {
        return (
          <div className='privacy-statement-link'>
            <span>{string.TURKEY_STRING1}</span>
            <a
              href='https://www8.hp.com/tr/tr/privacy/privacy.html'
              target='_blank'
              rel='noopener noreferrer'
            >
              {string.PRIVAY_STATEMENT_LINK}
            </a>
            <span>{string.TURKEY_STRING2}</span>
          </div>
        );
      }
      return (
        <div className='privacy-statement-link'>
          <span>{string.TURKEY_STRING}</span>
          <a
            href='https://www8.hp.com/us/en/privacy/privacy.html'
            target='_blank'
            rel='noopener noreferrer'
          >
            {string.PRIVACY_STATEMENT_LINK1}
          </a>
        </div>
      );
    }
    return null;
  };

  const submitAfterSaveActions = () => {
    dispatchers.blockChainActions.initiateCreateRequest(() => {
      if (envData && envData.wallart_lite_web_link) {
        dispatchers.finalCheckActions.addToCart(project.name);
      } else if (orderTitle === string.SAVE_INSPIRATION) {
        dispatchers.finalCheckActions.actionInspirationRedirect(project.name);
      } else if (
        orderTitle === string.ADD_TEMPLATE ||
        orderTitle === string.SAVE_TEMPLATE
      ) {
        dispatchers.finalCheckActions.actionTemplateRedirect(project.name);
      } else if (
        dispatchers.signageHelperFunctions.isTurkeyAccount() ||
        dispatchers.signageHelperFunctions.isBelgiumAccount() ||
        dispatchers.signageHelperFunctions.isShippingDetailsEnabled()
      ) {
        dispatchers.finalCheckActions.sendShippingDetails();
      } else {
        dispatchers.finalCheckActions.submitProject(project.name);
      }
    });
    finalCheckTimer();
  };

  const handleContentHeight = () => {
    if (isSignageSuiteProduct()) {
      return { overflow: 'auto', maxHeight: '66vh' };
    }
    return { height: '240px' };
  };

  const formElements = [];
  if (projectNameElement.canShow()) {
    formElements.push(projectNameElement);
  }
  if (firstNameElement.canShow()) {
    formElements.push(firstNameElement);
  }
  if (lastNameElement.canShow()) {
    formElements.push(lastNameElement);
  }
  if (addressElement.canShow()) {
    formElements.push(addressElement);
  }
  if (cityElement.canShow()) {
    formElements.push(cityElement);
  }
  if (countryElement.canShow()) {
    formElements.push(countryElement);
  }
  if (stateElement.canShow()) {
    formElements.push(stateElement);
  }
  if (zipCodelement.canShow()) {
    formElements.push(zipCodelement);
  }
  if (phoneNumberElement.canShow()) {
    formElements.push(phoneNumberElement);
  }
  if (customerNameElement.canShow()) {
    formElements.push(customerNameElement);
  }
  if (customerEmailElement.canShow()) {
    formElements.push(customerEmailElement);
  }
  if (companyNameElement.canShow()) {
    formElements.push(companyNameElement);
  }
  if (postalAddressElement.canShow()) {
    formElements.push(postalAddressElement);
  }
  if (orderNumberElement.canShow()) {
    formElements.push(orderNumberElement);
  }
  if (invoiceElement.canShow()) {
    formElements.push(invoiceElement);
  }
  if (serialNumberElement.canShow()) {
    formElements.push(serialNumberElement);
  }
  if (extraInfoElement.canShow()) {
    formElements.push(extraInfoElement);
  }
  if (instructionElement.canShow()) {
    formElements.push(instructionElement);
  }
  if (termsAndConditionsElement.canShow()) {
    formElements.push(termsAndConditionsElement);
  }
  if (personalInformationConditionElement.canShow()) {
    formElements.push(personalInformationConditionElement);
  }
  if (serviceProviderConditionElement.canShow()) {
    formElements.push(serviceProviderConditionElement);
  }

  const mainButtonColor = !storeData.commonSetting.useDefaultColors
    ? `#${storeData.commonSetting.mainButtonsColor}`
    : null;

  return (
    <div id='Form-container'>
      {moreInfoActiveElement ? (
        <Popover
          placement=''
          isOpen={moreInfoActiveElement && true}
          target={moreInfoActiveElement}
        >
          <SerialNumberDialogue
            closeAction={() => setMoreInfoActiveElement(null)}
          />
        </Popover>
      ) : null}

      <div>
        {isSignageSuiteProduct() ? (
          <span className='final-check-header'>{string.YOUR_DETAILS_KEY}</span>
        ) : null}
      </div>
      <div className='Form-sub-container' style={handleContentHeight()}>
        {envData.wallart_lite_web_link ? null : (
          <div className='w-100'>
            {formElements.map(formElement => (
              <CustomInput
                key={formElement.id}
                {...formElement}
                onChange={(value, id) => textChangeHandler(value, id)}
              />
            ))}
          </div>
        )}

        {checkForPrivacyStatement()}
        {dispatchers.homeActions.shouldShowLegalText() ? (
          <LegalText finalCheck />
        ) : null}

        <div className='button-container d-flex'>
          <button
            type='button'
            onClick={() => checkPixelation()}
            className='Button-container'
            style={{
              backgroundColor: envData.enterprise_account
                ? mainButtonColor
                : null
            }}
          >
            {orderTitle}
            {disableClickForSubmitButton ? (
              <img
                className='spinner'
                src={Icons.spinner_small}
                alt='loading'
              />
            ) : null}{' '}
          </button>
          {submitState == 'ERROR' ? (
            <div className='submit-error-finalcheck'>
              {string.ENTER_REQUIRED_FIELDS_KEY}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    project: state.finalCheck.project,
    orderFormData: state.finalCheck.orderFormData,
    envData: state.modal.envData,
    storeData: state.modal.storeData,
    feedbackState: state.fabricCanvas.feedbackState,
    projectSubmissionState: state.fabricCanvas.projectSubmissionState,
    category: state.modal.envData.category
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      formValidation: bindActionCreators(formValidation, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch),
      blockChainActions: bindActionCreators(blockChainActions, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch),
      saveProjectAndCall: bindActionCreators(saveProjectAndCall, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      ),
      setCurrentPageIndex: bindActionCreators(setCurrentPageIndex, dispatch),
      doesProjectHasPixelatedImage: bindActionCreators(
        doesProjectHasPixelatedImage,
        dispatch
      )
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(orderDetails);
